import React, { useState } from "react"; 
import { Button } from "../../components/template";

// Scoring mapping for each option: 
// A = 4 points, B = 3 points, C = 2 points, D = 1 point.
const scoreMapping = {
  0: 4,
  1: 3,
  2: 2,
  3: 1,
};

const quizData = [
  // Physical Well-being (Questions 1-6)
  {
    category: "Physical",
    question: "When I wake up, my energy levels are:",
    options: [
      "High and sustained throughout the day",
      "Generally good but fade later",
      "Moderate but inconsistent",
      "Low or non-existent",
    ],
  },
  {
    category: "Physical",
    question: "My breathing during the day is:",
    options: [
      "Deep and natural",
      "Normal but sometimes shallow",
      "Often shallow or unnoticed",
      "Restricted or effortful",
    ],
  },
  {
    category: "Physical",
    question: "My digestion and appetite are:",
    options: [
      "Consistently good",
      "Generally fine with occasional discomfort",
      "Often irregular or problematic",
      "Frequently poor or concerning",
    ],
  },
  {
    category: "Physical",
    question: "My activity levels throughout the day are:",
    options: [
      "High; I move frequently",
      "Moderate; I move regularly but sit often",
      "Low; I move infrequently",
      "Sedentary for most of the day",
    ],
  },
  {
    category: "Physical",
    question: "My stamina for physical tasks is:",
    options: [
      "Excellent; I can handle demanding tasks",
      "Good; I manage most tasks well",
      "Average; I tire quicker than I'd like",
      "Poor",
    ],
  },
  {
    category: "Physical",
    question: "My physical health over the last year has been:",
    options: [
      "Strong and improving",
      "Stable but could be better",
      "Declining in some areas",
      "Concerning and in need of attention",
    ],
  },

  // Mental Well-being (Questions 7-12)
  {
    category: "Mental",
    question: "My ability to focus on tasks is:",
    options: [
      "Excellent; I stay focused with ease",
      "Good, though I get distracted sometimes",
      "Moderate; I often struggle",
      "Poor; I lose focus",
    ],
  },
  {
    category: "Mental",
    question: "My ability to stay organized is:",
    options: [
      "Exceptional; I prioritize effectively",
      "Good, though I have occasional lapses",
      "Inconsistent; I struggle to stay organized",
      "Poor",
    ],
  },
  {
    category: "Mental",
    question: "When I need a mental break:",
    options: [
      "I take time to recharge effectively",
      "I try to rest but struggle to switch off",
      "I rarely take breaks until I’m burnt out",
      "I feel guilty about taking breaks",
    ],
  },
  {
    category: "Mental",
    question: "When I feel overwhelmed:",
    options: [
      "I pause and reassess calmly",
      "I push through but feel strained",
      "I struggle and get frustrated",
      "I shut down or avoid the situation",
    ],
  },
  {
    category: "Mental",
    question: "When making decisions, I:",
    options: [
      "Feel confident and clear",
      "Decide with some hesitation",
      "Often feel unsure",
      "Feel overwhelmed or avoid deciding",
    ],
  },
  {
    category: "Mental",
    question: "Over the past month, my mental clarity has been:",
    options: [
      "Strong and improving",
      "Generally stable",
      "Clouded or inconsistent",
      "Poor and in need of improvement",
    ],
  },

  // Emotional Well-being (Questions 13-18)
  {
    category: "Emotional",
    question: "When I feel strong emotions, I:",
    options: [
      "Express them openly and constructively",
      "Can manage but feel overwhelmed sometimes",
      "Struggle to communicate",
      "Avoid or suppress them",
    ],
  },
  {
    category: "Emotional",
    question: "In conflicts with others, I:",
    options: [
      "Address them with understanding and respect",
      "Work through them but feel tension",
      "Avoid or struggle to resolve them",
      "Feel unable to handle them",
    ],
  },
  {
    category: "Emotional",
    question: "When dealing with negative emotions, I:",
    options: [
      "Process them constructively and move forward",
      "Acknowledge them but feel unsettled",
      "Struggle to manage them effectively",
      "Avoid or suppress them entirely",
    ],
  },
  {
    category: "Emotional",
    question: "How often do I feel connected to others in my life?",
    options: [
      "Very often; I feel supported and loved",
      "Often, though I occasionally feel disconnected",
      "Rarely; I feel isolated at times",
      "Almost never; I feel lonely and detached",
    ],
  },
  {
    category: "Emotional",
    question: "When someone upsets me, I:",
    options: [
      "Respond calmly and communicate my feelings",
      "Try to manage but feel emotionally drained",
      "Get upset and hold onto resentment",
      "Withdraw or avoid the person altogether",
    ],
  },
  {
    category: "Emotional",
    question: "When reflecting on my emotional health, I:",
    options: [
      "Feel in control and balanced",
      "Notice occasional struggles but manage them",
      "Frequently feel overwhelmed or uneasy",
      "Feel disconnected or out of touch with myself",
    ],
  },
// Professional 

  {
    "category": "Professional",
    "question": "How often do I feel motivated at work?",
    "options": [
      "Always; I love my work.",
      "My motivation level changes frequently.",
      "Sometimes, when I get any reward or praise.",
      "Almost never; I don’t like my work or company."
    ]
  },
  {
    "category": "Professional",
    "question": "How often do I feel stressed or exhausted at work?",
    "options": [
      "Rarely; I stay calm and energized.",
      "Occasionally, but I recover quickly.",
      "Often; I feel drained.",
      "Almost always; I feel overwhelmed."
    ]
  },
  {
    "category": "Professional",
    "question": "How often do I make time for my health and family?",
    "options": [
      "Always; it’s my priority.",
      "Often, but work sometimes interferes.",
      "Rarely; I struggle to balance.",
      "Almost never; I’m too busy."
    ]
  },
  {
    "category": "Professional",
    "question": "My work leaves me feeling emotionally balanced:",
    "options": [
      "Almost always; it energizes me.",
      "Most of the time, with minor stress.",
      "Frequently stressed or emotionally drained.",
      "Constantly overwhelmed or anxious."
    ]
  },
  {
    "category": "Professional",
    "question": "My work brings me a sense of satisfaction:",
    "options": [
      "Daily; I feel fulfilled.",
      "Often; I feel good about most days.",
      "Occasionally; satisfaction is rare.",
      "Almost never; work feels empty."
    ]
  },
  {
    "category": "Professional",
    "question": "My work uses my strengths and talents well:",
    "options": [
      "Fully; I do what I’m best at.",
      "Mostly; some of my strengths are used.",
      "Occasionally; I feel underused.",
      "Rarely; my talents are overlooked."
    ]
  },


  // Spiritual Well-being (Questions 19-24)
  {
    category: "Spiritual",
    question: "How often do I feel aware of my thoughts, feelings, and actions?",
    options: [
      "Almost always; I feel deeply self-aware",
      "Often, though I occasionally lose awareness",
      "Rarely; I struggle to stay mindful",
      "Almost never; I feel disconnected from myself",
    ],
  },
  {
    category: "Spiritual",
    question: "How do I relate to people in my community?",
    options: [
      "I treat everyone with kindness and genuine care",
      "I am mostly supportive but sometimes distracted",
      "I am often neutral and indifferent",
      "I feel mostly disconnected or judgmental",
    ],
  },
  {
    category: "Spiritual",
    question: "My sense of purpose in life feels:",
    options: [
      "Clear and deeply meaningful",
      "Good, though it needs more exploration",
      "Unclear or uncertain",
      "Lacking entirely",
    ],
  },
  {
    category: "Spiritual",
    question: "When I reflect on my values, I:",
    options: [
      "Live by them consistently and feel aligned",
      "Acknowledge them but don't always follow through",
      "Struggle to define or prioritize them",
      "Rarely think about them",
    ],
  },
  {
    category: "Spiritual",
    question: "My sense of inner peace currently feels:",
    options: [
      "Strong and unwavering",
      "Stable but could be stronger",
      "Fluctuating or difficult to maintain",
      "Lacking or absent",
    ],
  },
  {
    category: "Spiritual",
    question: "How content do I feel with my life overall?",
    options: [
      "Very content; I feel at peace",
      "Mostly content, but occasionally dissatisfied",
      "Rarely content; I feel unsettled at times",
      "Almost never content; I feel unfulfilled",
    ],
  },
];

// Intro page component with quiz description and instructions
const IntroPage = ({ onStart }) => (
  <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-6 py-10">
    <div
      className="
        relative
        overflow-hidden
        rounded-[34px]
        max-w-5xl
        w-full
        h-[620px]
        shadow-[0_30px_80px_rgba(20,10,0,.12)]
      "
    >
      <img
        src="/assets/knowyourself/quiz/wellness.jpg"
        alt="Holistic Wellness Assessment"
        className="
          w-full
          h-full
          object-cover
          brightness-[.84]
          saturate-[.9]
        "
      />

      <div
        className="
          absolute
          inset-0
          bg-gradient-to-t
          from-black/90
          via-black/35
          to-transparent
        "
      />

      <div className="absolute inset-x-0 bottom-0 p-6">
        <div
          className="
            rounded-[28px]
            bg-white/10
            backdrop-blur-2xl
            border
            border-white/10
            p-8
          "
        >
          <div
            className="
              inline-flex
              px-4
              py-2
              rounded-full
              bg-white/10
              backdrop-blur-xl
              border
              border-white/10
              text-white
              text-xs
              tracking-[.08em]
              mb-5
            "
          >
            WELLNESS ASSESSMENT
          </div>

          <h1
            className="
              text-[38px]
              md:text-[56px]
              leading-[1.05]
              text-white
              mb-5
            "
          >
            Holistic Wellness Assessment
          </h1>

          <p
            className="
              text-white/75
              text-[15px]
              leading-8
              mb-4
            "
          >
            Discover where you currently stand across
            physical, mental, emotional, spiritual,
            and professional wellbeing.
          </p>

          <p
            className="
              text-white/75
              text-[15px]
              leading-8
              mb-8
            "
          >
            Answer honestly based on your current life
            experience to receive your overall wellness score.
          </p>

          <Button
            variant="primary"
            text="Start Assessment"
            onClick={onStart}
          />
        </div>
      </div>
    </div>
  </div>
);

// Quiz page component that renders questions one-by-one with a progress indicator and error messaging
const QuizPage = ({ onComplete }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  // Store answers as the index of the selected option for each question
  const [answers, setAnswers] = useState(Array(quizData.length).fill(null));
  const [error, setError] = useState("");

  const handleAnswerClick = (optionIndex) => {
    const updatedAnswers = [...answers];
    updatedAnswers[currentQuestion] = optionIndex;
    setAnswers(updatedAnswers);
    setError(""); // Clear error when an option is selected
  };

  const handleNext = () => {
    // Validate that an option has been selected before proceeding
    if (answers[currentQuestion] === null) {
      setError("Please select an option to proceed.");
      return;
    }
    setError("");
    if (currentQuestion < quizData.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      onComplete(answers);
    }
  };

  const handlePrev = () => {
    setError(""); // Clear error on navigating back
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const currentData = quizData[currentQuestion];
  const progressPercentage = ((currentQuestion + 1) / quizData.length) * 100;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-light px-6 py-10">
      <div className="w-full max-w-2xl bg-white p-8 rounded-2xl shadow-lg text-center">
        {/* Progress Indicator */}
        <div className="mb-6">
          <p className="text-sm text-gray-600 mb-2">
            Question {currentQuestion + 1} of {quizData.length}
          </p>
          <div className="w-full bg-gray-200 h-2 rounded-full">
            <div
              className="bg-primary h-2 rounded-full"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
        </div>

        <h2 className="text-lg text-primary mb-2">{currentData.category}</h2>
        <p className="mt-2 text-[#578d48] font-bold text-xl">{currentData.question}</p>
        <div className="mt-4 space-y-3">
          {currentData.options.map((option, index) => (
            <label
              key={index}
              className={`flex items-center justify-center p-3 rounded-lg cursor-pointer transition-colors 
                ${answers[currentQuestion] === index ? "bg-primary text-white" : "bg-gray-100 hover:bg-gray-200"}`}
            >
              <input
                type="radio"
                name={currentData.question}
                value={index}
                checked={answers[currentQuestion] === index}
                onChange={() => handleAnswerClick(index)}
                className="hidden"
              />
              <span className="text-sm">{option}</span>
            </label>
          ))}
        </div>
        {error && <p className="mt-4 text-red-500 text-sm">{error}</p>}
      </div>
      <div className="flex mt-6 space-x-4">
        {currentQuestion > 0 && (
          <Button onClick={handlePrev} text="Previous" variant="whitish" />
        )}
        <Button
          onClick={handleNext}
          text={currentQuestion === quizData.length - 1 ? "Submit" : "Next"}
          variant="primary"
        />
      </div>
    </div>
  );
};

// Result page component that calculates and displays the total score and interpretation
const ResultPage = ({ answers, onRetake }) => {
  const totalScore = answers.reduce(
    (acc, answerIndex) => acc + scoreMapping[answerIndex],
    0
  );

  let title = "";
  let resultMessage = "";

  if (totalScore >= 100) {
    title = "🌟 Thriving";

    resultMessage =
      "You have a strong balance across physical, mental, emotional, spiritual, and professional wellbeing. Continue nurturing the habits that are helping you thrive and stay aligned.";
  } else if (totalScore >= 80) {
    title = "🌱 Moderate Wellness";

    resultMessage =
      "You are doing well overall, but a few areas may benefit from greater attention. Small improvements in daily habits can significantly elevate your overall wellbeing.";
  } else if (totalScore >= 60) {
    title = "⚡ Needs Attention";

    resultMessage =
      "Several areas of your wellbeing may be under strain. This is a good opportunity to identify priorities and begin making conscious changes toward a healthier, more balanced lifestyle.";
  } else {
    title = "🚨 Immediate Intervention Recommended";

    resultMessage =
      "Your overall wellness score suggests significant imbalance across multiple areas of life. Focus on rebuilding foundations through better self-care, support systems, recovery, and sustainable routines.";
  }

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-6 py-10">
      <div
        className="
          relative
          overflow-hidden
          rounded-[34px]
          max-w-5xl
          w-full
          h-[620px]
          shadow-[0_30px_80px_rgba(20,10,0,.12)]
        "
      >
        <img
          src="/assets/knowyourself/quiz/result.jpg"
          alt="Assessment Result"
          className="
            w-full
            h-full
            object-cover
            brightness-[.84]
            saturate-[.9]
          "
        />

        <div
          className="
            absolute
            inset-0
            bg-gradient-to-t
            from-black/90
            via-black/35
            to-transparent
          "
        />

        <div className="absolute inset-x-0 bottom-0 p-6">
          <div
            className="
              rounded-[28px]
              bg-white/10
              backdrop-blur-2xl
              border
              border-white/10
              p-8
            "
          >
            <div
              className="
                inline-flex
                px-4
                py-2
                rounded-full
                bg-white/10
                backdrop-blur-xl
                border
                border-white/10
                text-white
                text-xs
                tracking-[.08em]
                mb-5
              "
            >
              YOUR RESULT
            </div>

            <h2
              className="
                text-[34px]
                md:text-[52px]
                leading-[1.05]
                text-white
                mb-4
              "
            >
              {title}
            </h2>

            <p
              className="
                text-white/75
                text-[15px]
                leading-8
                mb-4
              "
            >
              Wellness Score: {totalScore}
            </p>

            <p
              className="
                text-white/75
                text-[15px]
                leading-8
                mb-8
                max-w-3xl
              "
            >
              {resultMessage}
            </p>

            <Button
              variant="primary"
              text="Retake Assessment"
              onClick={onRetake}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// Main quiz component that handles the flow
const HolisticWellnessQuiz = () => {
  const [quizStarted, setQuizStarted] = useState(false);
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [answers, setAnswers] = useState(null);

  const startQuiz = () => setQuizStarted(true);
  const completeQuiz = (answers) => {
    setAnswers(answers);
    setQuizCompleted(true);
  };
  const retakeQuiz = () => {
    setQuizStarted(false);
    setQuizCompleted(false);
    setAnswers(null);
  };

  return (
    <div>
      {!quizStarted ? (
        <IntroPage onStart={startQuiz} />
      ) : quizCompleted ? (
        <ResultPage answers={answers} onRetake={retakeQuiz} />
      ) : (
        <QuizPage onComplete={completeQuiz} />
      )}
    </div>
  );
};

export default HolisticWellnessQuiz;
